export default __webpack_public_path__ + "static/media/hbs-k-cbb-poster-2.56451526.jpg";